import { render, staticRenderFns } from "./VideoPlayerFullgame.vue?vue&type=template&id=5475fc9a&"
import script from "./VideoPlayerFullgame.vue?vue&type=script&lang=js&"
export * from "./VideoPlayerFullgame.vue?vue&type=script&lang=js&"
import style0 from "./VideoPlayerFullgame.vue?vue&type=style&index=0&id=5475fc9a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports